import { useAppSelector } from "@app/hooks";
import { LModal } from "@components/LModal";
import { NavItems } from "@helpers/navigation";
import { InternetStatus } from "@store/generalTypes";
import { Translate, translate } from "react-i18nify";
import { useNavigate } from "react-router";

export const InternetConnectionModal = (): JSX.Element => {
    const navigate = useNavigate();
    const internetConnection = useAppSelector((x) => x.internetConnection);

    return (
        <>
            {internetConnection.status !== InternetStatus.Online && (
                <LModal
                    title={
                        <p className="has-text-centered has-text-weight-bold is-size-3">
                            <Translate value="internet.textModal" />
                        </p>
                    }
                    fullHeight={false}
                    width="m"
                    hasCancelConfirmButtons
                    confirmText={translate("continue")}
                    cancelText=""
                    hasCloseButton={false}
                    divider={false}
                    onConfirm={() => {
                        navigate(NavItems.Login.Landing.path);
                    }}
                    onClose={() => {}}
                >
                    <div className="is-flex is-flex-direction-column">
                        <p className="content has-text-centered is-size-4">
                            <Translate value="internet.detailModal" />
                        </p>
                        <p className="content has-text-centered is-size-4">
                            <Translate value="internet.detailModal2" />
                        </p>
                    </div>
                </LModal>
            )}
        </>
    );
};

export default InternetConnectionModal;
